import { ListItem as MuiListItem, ListItemButton, ListItemText } from '@mui/material';
import { StyledItemDivider } from './ListItem.styles';
import { ReactNode } from 'react';

export interface ISalonItem {
  name: string;
  action: () => void;
  icon?: ReactNode;
  disabled?: boolean;
}

export const ListItem = ({ name, action, icon, disabled = false }: ISalonItem) => {
  return (
    <>
      <MuiListItem disablePadding>
        <ListItemButton disabled={disabled} onClick={action}>
          <ListItemText primary={name} />
          {icon}
        </ListItemButton>
      </MuiListItem>
      <StyledItemDivider />
    </>
  );
};
